"use strict"
exports.__esModule = true;
exports.UnsplashIconConfig = {
  name: 'UnsplashIcon',
  height: 512,
  width: 448,
  svgPath: 'M448,230.17V480H0V230.17H141.13V355.09H306.87V230.17ZM306.87,32H141.13V156.91H306.87Z',
  yOffset: 0,
  xOffset: 0,
};
exports.UnsplashIcon = require('../createIcon').createIcon(exports.UnsplashIconConfig);
exports["default"] = exports.UnsplashIcon;